import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

Vue.config.productionTip = false;

Vue.mixin({
	created: function () {
		this.gsap = gsap;
		gsap.registerPlugin(ScrollTrigger);
	},
});

new Vue({
	router,
	render: (h) => h(App),
}).$mount('#app');
